import * as THREE from 'three';
import FloatingCube from './FloatingCube';
import AudioManager from '../audio/AudioManager.js';

export default class CubeManager {
    constructor(scene, physics, audioManager) {
        this.scene = scene;
        this.physics = physics;
        this.cubes = [];
        this.audioManager = audioManager;
        this.spawnArea = {
            minX: -500,
            maxX: 500,
            minZ: -500,
            maxZ: 500
        };
        this.minDistance = 100; // Minimum distance between cubes
    }

    initialize(count = 1000) {
        for (let i = 0; i < count; i++) {
            this.spawnCube();
        }
    }

    spawnCube() {
        let position;
        let attempts = 0;
        const maxAttempts = 10;

        // Try to find a valid position that's not too close to other cubes
        do {
            position = {
                x: this.spawnArea.minX + Math.random() * (this.spawnArea.maxX - this.spawnArea.minX),
                z: this.spawnArea.minZ + Math.random() * (this.spawnArea.maxZ - this.spawnArea.minZ)
            };
            attempts++;
        } while (this.isPositionTooClose(position) && attempts < maxAttempts);

        // Create new cube at the found position
        const cube = new FloatingCube(this.scene, this.physics, position, this.audioManager);
        this.cubes.push(cube);
    }

    isPositionTooClose(position) {
        return this.cubes.some(cube => {
            const dx = cube.position.x - position.x;
            const dz = cube.position.z - position.z;
            const distance = Math.sqrt(dx * dx + dz * dz);
            return distance < this.minDistance;
        });
    }

    update(bus) {
        if (!bus || !bus.mesh) return;
        
        this.cubes.forEach(cube => {
            cube.update(bus.mesh.position);
        });
    }

    removeCube(cube) {
        const index = this.cubes.indexOf(cube);
        if (index !== -1) {
            cube.remove();
            this.cubes.splice(index, 1);
            // Play explosion sound when cube is removed
            if (this.audioManager) {
                this.audioManager.playSoundEffect('cube_explode');
            }
        }
    }

    clear() {
        while (this.cubes.length > 0) {
            this.removeCube(this.cubes[0]);
        }
    }
}